module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('acWrap', [_c('div', {
    staticClass: "rg-con"
  }, [_c('p', {
    staticClass: "rg-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "rg-content"
  }, [_c('acRegistry', {
    on: {
      "change": _vm.change
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3267e60","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/account/Registry.vue
// module id = 1278
// module chunks = 2